import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import { DebugMode } from '../contexts';
export function i18nRegion({ region, label }, debug) {
    const translation = I18nAPI.translate('regions', region);
    if (debug) {
        return region + (translation ? '*' : '');
    }
    return translation || label || region;
}
const Region = props => {
    const debugEnabled = React.useContext(DebugMode);
    return React.createElement(React.Fragment, null, i18nRegion(props, debugEnabled));
};
export default Region;
//# sourceMappingURL=Region.js.map